import React, { useEffect, useState } from 'react';
import isEmail from 'validator/lib/isEmail';
import { useTranslation } from 'react-i18next';

export const useEmailForm = (email?: string, disableInit?: boolean): [InputState, (event: React.SyntheticEvent) => void] => {
  const { t } = useTranslation();

  const [emailState, setEmailState] = useState<InputState>({
    error: false,
    helperText: '',
    inputValue: disableInit ? '' : localStorage.getItem('emailRemember') || '',
    shrink: true,
  });

  useEffect(() => {
    if (email && email !== '') {
      if (!isEmail(email)) {
        setEmailState({ ...emailState, inputValue: email, helperText: '* ' + t('invalidEmail'), error: true });
      } else {
        setEmailState({ ...emailState, inputValue: email, helperText: '', error: false });
      }
    }
  }, [email]);

  const onEmailFormChange = (event: React.SyntheticEvent) => {
    const target = event.target as HTMLInputElement;
    if (!isEmail(target.value)) {
      setEmailState({
        error: true,
        helperText: '* ' + t('invalidEmail'),
        inputValue: target.value.trim(),
        shrink: target.value !== '',
      });
    } else {
      setEmailState({
        error: false,
        helperText: '',
        inputValue: target.value.trim(),
        shrink: target.value !== '',
      });
    }
  };

  return [emailState, onEmailFormChange];
};

interface InputState {
  inputValue: string;
  error: boolean;
  helperText: string;
  shrink: boolean;
}
